import { without } from 'lodash';
import { taskStatus } from '../../js/constants';
import { ACTION_TYPES as TASKS_ACTION_TYPES } from '../tasks/constants';
import { ACTION_TYPES as PROJECTS_ACTION_TYPES } from '../projects/constants';
import { ACTION_TYPES } from './constants';

const defaultState = {
  taskTmpProperties: {
    taskTitle: '',
    taskDescription: '',
    cost: 0,
    dueDate: '',
    section: '',
    isCompleted: false,
  },
  openedTaskId: null,
  sectionsByProjectId: {},
  fetchingTaskError: null,
  // selectedUserFilter: {},
  tasksCustomFilters: [],
  projectTasks: {},
  dashboardTasks: {},
  visibleSectionIdList: [],
};

const generalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case TASKS_ACTION_TYPES.GET_TASKS_REQUEST_SUCCESS:
      return {
        ...state,
        sectionsByProjectId: {
          ...(state?.sectionsByProjectId || {}),
          [action?.payload?.projectId]: Object.keys(
            action?.payload?.sections || {},
          ),
        },
        tasksByProjectId: {
          ...(state?.tasksByProjectId || {}),
          [action?.payload?.projectId]: action?.payload?.tasksResults,
        },
      };
    case TASKS_ACTION_TYPES.GET_TASKS_INFINITE_LIST_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        tasksByProjectId: {
          ...(state?.tasksByProjectId || {}),
          [action?.payload?.projectId]: Array.from(
            new Set([
              ...(state?.tasksByProjectId?.[action?.payload?.projectId] || []),
              ...(action?.payload?.tasksResults || []),
            ]),
          ),
        },
      };
    case TASKS_ACTION_TYPES.GET_SECTION_TASKS_REQUEST_SUCCESS:
      return {
        ...state,
        tasksByProjectId: {
          ...(state?.tasksByProjectId || {}),
          [action?.payload?.projectId]: Array.from(
            new Set([
              ...(state?.tasksByProjectId?.[action?.payload?.projectId] || []),
              ...(action?.payload?.appendedTaskIdList || []),
            ]),
          ),
        },
      };
    case TASKS_ACTION_TYPES.GET_TASK_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS:
      // if (action.payload.doNotOpen) {
        return state;
      // }
      // return {
      //   ...state,
      //   openedTaskId: action?.payload?.taskId,
      // };
    case TASKS_ACTION_TYPES.OPEN_TASK_ACTION: {
      return {
        ...state,
        openedTaskId: action?.payload?.taskId,
      }
    }
    case TASKS_ACTION_TYPES.ADD_TASK_SUCCESS: {
      const projectId = action?.payload?.task?.projectId;

      if (action?.payload?.task?.parentTaskId) {
        return {
          ...state,
          tasksByProjectId: {
            ...(state?.tasksByProjectId || {}),
            [projectId]: Array.from(
              new Set([
                ...(state?.tasksByProjectId?.[projectId] || []),
                action?.payload?.taskId,
              ]),
            ),
          },
        };
      }

      return {
        ...state,
        openedTaskId: action?.payload?.hasOpenedTask
          ? action?.payload?.taskId
          : null,
        tasksByProjectId: {
          ...(state?.tasksByProjectId || {}),
          [projectId]: Array.from(
            new Set([
              ...(state?.tasksByProjectId?.[projectId] || []),
              action?.payload?.taskId,
            ]),
          ),
        },
      };
    }
    case TASKS_ACTION_TYPES.ADD_TASK_EVENT: {
      const projectId = action?.payload?.task?.projectId;

      return {
        ...state,
        tasksByProjectId: {
          ...(state?.tasksByProjectId || {}),
          [projectId]: Array.from(
            new Set([
              ...(state?.tasksByProjectId?.[projectId] || []),
              action?.payload?.taskId,
            ]),
          ),
        },
      };
    }
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_ERROR:
      return {
        ...state,
        fetchingTaskError: action?.payload?.error,
      };
    case TASKS_ACTION_TYPES.DELETE_TASK_REQUEST:
    case TASKS_ACTION_TYPES.REMOVE_TASK_EVENT: {
      if (state.openedTaskId !== action?.payload?.taskId) {
        return state;
      }
      return {
        ...state,
        openedTaskId: null,
      };
    }
    case TASKS_ACTION_TYPES.SET_TMP_TASK_PROPS: {
      return {
        ...state,
        taskTmpProperties: action?.payload,
      };
    }
    case TASKS_ACTION_TYPES.CLEAR_OPENED_TASK_ID:
      return {
        ...state,
        openedTaskId: null,
      };
    case TASKS_ACTION_TYPES.GET_USER_TASKS_REQUEST_SUCCESS: {
      const isPaginated = action?.payload?.page > 1;
      const previousIdList = state?.userTasks?.idList || [];
      const incomingIdList = action?.payload?.tasksIdList || [];
      const idList = isPaginated
        ? Array.from(new Set([...previousIdList, ...incomingIdList]))
        : incomingIdList;
      // While paginating, a page that brings no new task ids means we've
      // reached the end of the list — stop requesting further pages.
      const hasMore = isPaginated ? idList.length > previousIdList.length : true;
      return {
        ...state,
        userTasks: {
          ...(state?.userTasks || {}),
          idList,
          page: action?.payload?.page || 1,
          count:
            isPaginated && incomingIdList.length === 0
              ? (state?.userTasks?.count ?? action.payload.count)
              : action.payload.count,
          hasMore,
        },
      };
    }
    case TASKS_ACTION_TYPES.CLEAR_USER_TASKS:
      return {
        ...state,
        userTasks: {},
      };
    // value selectedUserFilter is never used
    // case ACTION_TYPES.SAVE_CUSTOM_TASKS_FILTER:
    //   return {
    //     ...state,
    //     selectedUserFilter: action.payload,
    //   };
    case ACTION_TYPES.GET_CUSTOM_TASKS_FILTERS:
      return {
        ...state,
        tasksCustomFilters: action.payload,
      };
    case TASKS_ACTION_TYPES.SET_PROJECT_TASKS_FILTERS:
      return {
        ...state,
        projectTasks: {
          ...(state?.projectTasks || {}),
          filters: action.payload.filters,
        },
      };
    case TASKS_ACTION_TYPES.SET_USER_TASKS_FILTERS: {
      return {
        ...state,
        userTasks: {
          ...(state?.userTasks || {}),
          filters: !action.payload.reset
            ? action.payload.filters
            : {
              status: taskStatus.allTasks.key,
              priority: [],
              assignedTo: [],
              projects: [],
              creator: [],
              customFields: {},
            },
          page: 1,
          hasMore: true,
        },
      };
    }
    case ACTION_TYPES.DELETE_USER_FILTER_RESULTS: {
      const taskId = action?.payload;

      const updatedIdList = without(state?.userTasks?.idList || [], taskId);
      return {
        ...state,
        userTasks: {
          ...(state?.userTasks || {}),
          idList: updatedIdList,
          count: (state?.userTasks?.count - 1 || 0)
        },
      };
    }
    case ACTION_TYPES.ADD_TASK_TO_USER_FILTER_RESULTS: {
      const task = action?.payload;
      const selectedFilters = state?.userTasks?.filters || {};
      const isTaskInState = (state?.userTasks?.idList || []).includes(
        task?._id,
      );
      const currentTasksIdList = state?.userTasks?.idList || [];
      const withoutTaskIdList = without(currentTasksIdList, task?._id);

      const matchMap = {
        projects: false,
        assignedTo: false,
        priority: false,
        creator: false,
        resolution: false,
        customFields: false,
      };

      if (selectedFilters?.projects?.length > 0) {
        for (let p of selectedFilters?.projects) {
          if (
            task?.projects?.some(
              (pr) => pr?.project?._id?.toString() === p?._id?.toString() ||
                pr?.projectId?.toString() === p?._id?.toString() ||
                (typeof pr?.project === 'string' && pr?.project === p?._id?.toString())
            )
          ) {
            matchMap.projects = true;
            break;
          }
        }
        if (!matchMap.projects) {
          return {
            ...state,
            userTasks: {
              ...(state?.userTasks || {}),
              idList: isTaskInState ? withoutTaskIdList : currentTasksIdList,
              count: isTaskInState
                ? (state?.userTasks?.count - 1 || 0)
                : (state?.userTasks?.count || 0)
            },
          };
        }
      }

      if (selectedFilters?.priority?.length > 0) {
        for (let p of selectedFilters?.priority) {
          if (task?.priority === p?._id) {
            matchMap.priority = true;
            break;
          }
        }
        if (!matchMap.priority) {
          return {
            ...state,
            userTasks: {
              ...(state?.userTasks || {}),
              idList: isTaskInState ? withoutTaskIdList : currentTasksIdList,
              count: isTaskInState
                ? (state?.userTasks?.count - 1 || 0)
                : (state?.userTasks?.count || 0)
            },
          };
        }
      }

      if (selectedFilters?.creator?.length > 0) {
        for (let p of selectedFilters?.creator) {
          if (task?.createdBy?.toString() === p?._id?.toString()) {
            matchMap.creator = true;
            break;
          }
        }
        if (!matchMap.creator) {
          return {
            ...state,
            userTasks: {
              ...(state?.userTasks || {}),
              idList: isTaskInState ? withoutTaskIdList : currentTasksIdList,
              count: isTaskInState
                ? (state?.userTasks?.count - 1 || 0)
                : (state?.userTasks?.count || 0)
            },
          };
        }
      }

      if (selectedFilters?.resolution?.length > 0) {
        for (let p of selectedFilters?.resolution) {
          if (task?.isCompleted === p?._id) {
            matchMap.resolution = true;
            break;
          }
        }
        if (!matchMap.resolution) {
          return {
            ...state,
            userTasks: {
              ...(state?.userTasks || {}),
              idList: isTaskInState ? withoutTaskIdList : currentTasksIdList,
              count: isTaskInState
                ? (state?.userTasks?.count - 1 || 0)
                : (state?.userTasks?.count || 0)
            },
          };
        }
      }

      if (Object.keys(selectedFilters?.customFields || {})?.length > 0) {
        for (let [
          selectedCustomFieldId,
          selectedCustomFieldValueList,
        ] of Object.entries(selectedFilters?.customFields)) {
          const taskCustomField = task?.customFields?.find(
            (cf) => cf?._id?.toString() === selectedCustomFieldId?.toString(),
          );
          if (taskCustomField) {
            // Proves task has the filter custom field
            if (
              selectedCustomFieldValueList?.find(
                (value) =>
                  value?._id?.toString() === taskCustomField?.value?.toString(),
              )
            ) {
              matchMap.customFields = true;
              break;
            }
          }
        }

        if (!matchMap.customFields) {
          return {
            ...state,
            userTasks: {
              ...(state?.userTasks || {}),
              idList: isTaskInState ? withoutTaskIdList : currentTasksIdList,
              count: isTaskInState
                ? (state?.userTasks?.count - 1 || 0)
                : (state?.userTasks?.count || 0)
            },
          };
        }
      }

      if (isTaskInState) {
        // Task is already in state.
        return state;
      }

      const updatedIdList = [task?._id, ...currentTasksIdList];

      return {
        ...state,
        userTasks: {
          ...(state?.userTasks || {}),
          idList: updatedIdList,
          count: (state?.userTasks?.count || 0) + 1,
        },
      };
    }
    case TASKS_ACTION_TYPES.GET_DASHBOARD_TASKS_REQUEST_SUCCESS: {
      return {
        ...state,
        dashboardTasks: {
          ...(state?.dashboardTasks || {}),
          idList: Array.from(
            new Set([
              ...(state?.dashboardTasks?.idList || []),
              ...action?.payload?.tasksIdList,
            ]),
          ),
          page: (state?.dashboardTasks?.page || 0) + 1,
          completedTasks: action?.payload?.completedTasks,
          totalTasks: action?.payload?.totalTasks,
          unassignedTasks: action?.payload?.unassignedTasks,
        },
      };
    }
    case ACTION_TYPES.SET_VISIBLE_SECTION_ID_LIST: {
      return {
        ...state,
        visibleSectionIdList: action?.payload?.sectionIdList,
      };
    }
    case ACTION_TYPES.CLEAR_VISIBLE_SECTION_ID_LIST: {
      return {
        ...state,
        visibleSectionIdList: defaultState.visibleSectionIdList,
      };
    }
    case ACTION_TYPES.REMOVE_FROM_VISIBLE_SECTION_ID_LIST: {
      return {
        ...state,
        visibleSectionIdList: without(
          state?.visibleSectionIdList || defaultState.visibleSectionIdList,
          action?.payload?.sectionId,
        ),
      };
    }
    case ACTION_TYPES.LOGOUT:
      return defaultState;
    case TASKS_ACTION_TYPES.ADD_TASK_TO_PROJECT_REQUEST_SUCCESS: {
      const { taskId, projectId } = action.payload || {};

      return {
        ...state,
        tasksByProjectId: {
          ...(state.tasksByProjectId || {}),
          [projectId]: [...(state.tasksByProjectId?.[projectId] || []), taskId],
        },
      }
    }
    case PROJECTS_ACTION_TYPES.GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_SUCCESS: {
      const { projectId, sections } = action.payload || {};
      return {
        ...state,
        sectionsByProjectId: {
          ...(state.sectionsByProjectId || {}),
          [projectId]: sections
        }
      }
    }
    case TASKS_ACTION_TYPES.UPDATE_TASK_EVENT: {
      const { taskId, task: { projectAndSectionLabelList } = {}, prevProjects } = action.payload || {};

      const currentTasksByProjectId = state?.tasksByProjectId || {};
      const updatedCurrentTasksByProjectIdState = {};
      const newProjects = [];

      Object.values(projectAndSectionLabelList).forEach(({ projectId }) => {
        newProjects.push(projectId);
        const currentProjectId = currentTasksByProjectId?.[projectId] || [];
        const hasTaskInCurrentProjectId = currentProjectId.includes(taskId);

        if (!hasTaskInCurrentProjectId) {
          updatedCurrentTasksByProjectIdState[projectId] = [...currentProjectId, taskId];
        }
      });
      (prevProjects || []).forEach((prevPrjId) => {
        if (!newProjects.includes(prevPrjId)) {
          const currentProjectId = currentTasksByProjectId?.[prevPrjId] || [];
          updatedCurrentTasksByProjectIdState[prevPrjId] = without(currentProjectId, taskId)
        }
      });
      return {
        ...state,
        tasksByProjectId: {
          ...currentTasksByProjectId,
          ...updatedCurrentTasksByProjectIdState
        }
      };
    }
    case TASKS_ACTION_TYPES.SET_PROJECT_TASKS_SORTS:
      return {
        ...state,
        projectTasks: {
          ...(state?.projectTasks || {}),
          sorts: action.payload.sorts,
        },
      };
    default: {
      return state;
    }
  }
};

export default generalReducer;
